import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Dimension } from '../../models/dimension.model';
import { Question } from '../../models/question.model';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationnDialogComponent } from '../../modal/confirmation-dialog/confirmation-dialog.component';
import { AlertService } from '../../service/alert.service';
import { MatRadioGroup, MatRadioButton } from "@angular/material/radio";
import { MatStepper, MatStep } from "@angular/material/stepper";
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from "@angular/material/button";
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-fill-questionnaire',
  templateUrl: './fill-questionnaire.component.html',
  standalone: true,
  styleUrls: ['./fill-questionnaire.component.css'],
  imports: [MatRadioGroup, MatRadioButton, ReactiveFormsModule, MatStepper, MatStep, MatIcon, CommonModule, MatButtonModule, MatStepperModule, TranslateModule]
})
export class FillQuestionnaireComponent implements OnInit {
  isLinear = true;
  returnUrl: string = '/';
  dimensions: Dimension[] = [];
  dimensionForms: FormGroup[] = [];

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private alertService: AlertService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const token = localStorage.getItem('token');
    const headers = { Authorization: `Bearer ${token}` };

    this.http.get<any[]>(environment.apiUrl + `/api/questions`, { headers }).subscribe((questions) => {
      console.log('Fetched questions:', questions);
      const groupedDimensions = this.groupQuestionsByDimension(questions);
      this.dimensions = groupedDimensions;
      this.initStepper(groupedDimensions);

      console.log('Grouped dimensions:', this.dimensions);
      console.log('dentro ngoninit:', this.dimensionForms);
    });

    this.route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        this.returnUrl = params['returnUrl'];
      }
    });
  }

  groupQuestionsByDimension(questions: any[]): Dimension[] {
    const groupedMap: { [key: string]: Dimension } = {};

    questions.forEach((q) => {
      const dimName = q.dimension.name;
      const dimKey = q.dimension.code;
      if (!groupedMap[dimName]) {
        groupedMap[dimName] = {
          dimensionName: dimName,
          dimensionCode: dimKey,
          average: 0,
          questions: []
        };
      }

      groupedMap[dimName].questions.push({
        questionId: q.id,
        questionCode: q.code,
        questionText: q.text,
        answerValue: null
      });
    });

    return Object.values(groupedMap);
  }

  initStepper(dimensions: Dimension[]) {
    this.dimensionForms = [];

    dimensions.forEach((dim) => {
      const group: { [key: string]: any } = {};

      dim.questions.forEach((question, index) => {
        group[`question${index + 1}`] = this.fb.control(null, Validators.required);
      });

      this.dimensionForms.push(this.fb.group(group));
    });

    console.log('Initialized dimension forms:', this.dimensionForms);
  }

  submit() {
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { 
      message: this.translate.instant('fill-questionnaire.confirm-submit')
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const answers: { questionId: number; value: number }[] = [];

        this.dimensions.forEach((dim, dimIndex) => {
          const formGroup = this.dimensionForms[dimIndex];

          dim.questions.forEach((question, qIndex) => {
            const value = formGroup.get(`question${qIndex + 1}`)?.value;
            if (value !== null && value !== undefined) {
              answers.push({
                questionId: question.questionId,
                value: value
              });
            }
          });
        });

        const payload = { answers };
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        this.http.post(environment.apiUrl + '/api/questionnaires', payload, { headers,responseType: 'text'})
          .subscribe({
            next: () => {
              this.alertService.successKey('fill-questionnaire.submit-success')
              this.router.navigateByUrl(this.returnUrl);
            },
            error: err => {
              console.error('Error submitting questionnaire', err);
              this.alertService.errorKey('fill-questionnaire.submit-error')
            }
          });
      }
      else {
        console.log('Invio questionario annullato');
      }
    });
  }


  goBack() {
    this.router.navigateByUrl(this.returnUrl);
  }
}
